import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from 'vue';

import { MonetizationType } from '@/@types/graphql-types';

import type { TitleDetail } from '@/interfaces/title-details-graphql';
import { useSpinningText } from '@/helpers/composables/useSpinningText';
import { useLanguageStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyRent',
  props: {
    title: null,
    offers: null,
    seasonNumber: null
  },
  setup(__props: any) {

const props = __props as {
	title: string;
	offers: TitleDetail['offers'];
	seasonNumber?: number | undefined;
};

const { language } = useLanguageStore();



const { getOfferTextBlock, getInfoTextBlock, getRTLInfoTextBlock } = useSpinningText(toRefs(props));

const text = computed(() => {
	switch (language.value) {
		case 'fi':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'Voit ostaa elokuvan', 'palvelussa'),
				getOfferTextBlock(MonetizationType.Rent, ' tai vuokrata sen netissä palvelussa'),
				'. ',
			];
		case 'ru':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'Вы можете купить и скачать', 'на'),
				getOfferTextBlock(MonetizationType.Rent, ' или взять напрокат на', 'онлайн'),
				'. ',
			];
		case 'it':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'Puoi comprare', 'scaricandolo da'),
				getOfferTextBlock(MonetizationType.Rent, ' o noleggiarlo online su'),
				'. ',
			];
		case 'de':
			return [
				getInfoTextBlock(MonetizationType.Rent, 'Du kannst', 'bei', 'online leihen'),
				getOfferTextBlock(MonetizationType.Buy, ' oder bei', 'als Download kaufen'),
				'. ',
			];
		case 'pt':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'Você pode assistir', 'no', 'para comprar o Download'),
				getOfferTextBlock(MonetizationType.Rent, ' ou no', 'alugando online'),
				'. ',
			];
		case 'fr':
			return [
				getInfoTextBlock(MonetizationType.Rent, 'Il est possible de louer', 'sur', 'en ligne'),
				getOfferTextBlock(MonetizationType.Buy, ' et de télécharger sur'),
				'. ',
			];
		case 'es':
			return [
				getInfoTextBlock(MonetizationType.Rent, 'Es posible alquilar', 'en', 'online'),
				getOfferTextBlock(MonetizationType.Buy, ' y comprarlo como descarga en'),
				'. ',
			];
		case 'ja':
			return [
				getInfoTextBlock(MonetizationType.Rent, 'は', 'で配信版のレンタルができます。'),
				getOfferTextBlock(MonetizationType.Buy, '配信版を購入してダウンロードする場合は', 'です'),
				'。',
			];
		case 'ko':
			return [
				getOfferTextBlock(MonetizationType.Rent, '현재 ', `에서 "${props.title}" 대여가 가능하며 `),
				getOfferTextBlock(MonetizationType.Buy, '', '에서 유료 다운로드하실 수 있습니다.'),
			];
		case 'ro':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'Puteți să cumpărați', 'pe', 'prin descărcare'),
				getOfferTextBlock(MonetizationType.Rent, ' sau să-l închiriați pe', 'online'),
				'. ',
			];
		case 'hu':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'A(z)', 'megvásárolható a(z)', 'szolgáltatónál letöltésként'),
				getOfferTextBlock(MonetizationType.Rent, ' vagy online kibérelhető itt:'),
				'. ',
			];
		case 'cs':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'si můžete zakoupit', 'u', 'ke stažení'),
				getOfferTextBlock(MonetizationType.Rent, ' nebo si jej půjčit u', 'online'),
				'. ',
			];
		case 'bg':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'Можете да купите', 'в', 'като изтеглена версия'),
				getOfferTextBlock(MonetizationType.Rent, ' или да го наемете', 'онлайн'),
				'. ',
			];
		case 'ar':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'بإمكانكم شراء', 'على', 'وتنزيله'),
				getOfferTextBlock(MonetizationType.Rent, ' أو تأجيره على', 'أونلاين'),
				'. ',
			];
		case 'pt':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'Você pode comprar', 'via', 'como download'),
				getOfferTextBlock(MonetizationType.Rent, ' ou alugar online via'),
				'. ',
			];
		case 'tr':
			return [
				getInfoTextBlock(MonetizationType.Buy, '', 'adlı yapımı', 'üzerinden satın alarak indirebilir veya'),
				getOfferTextBlock(MonetizationType.Rent, ' ', 'üzerinden kiralayıp çevrimiçi olarak izleyebilirsiniz'),
				'. ',
			];
		case 'sq':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'Ju mund ta blini', 'në', 'si shkarkim'),
				getOfferTextBlock(MonetizationType.Rent, ' ose ta merrni me qira në', 'online'),
				'. ',
			];
		case 'pl':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'Możesz kupić', 'jako plik do pobrania w serwisie'),
				getOfferTextBlock(MonetizationType.Rent, ' lub wypożyczyć go online w serwisie'),
				'. ',
			];
		case 'ro':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'Poți să cumperi și să descarci', 'pe'),
				getOfferTextBlock(MonetizationType.Rent, ' sau să-l închiriezi online pe'),
				'. ',
			];
		case 'az':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'Siz', 'filmini', 'vasitəsilə alaraq endirə'),
				getOfferTextBlock(MonetizationType.Rent, ' və ya', 'saytında onlayn icarəyə götürə bilərsiniz'),
				'. ',
			];
		case 'el':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'Μπορείτε να αγοράσετε τον τίτλο', 'στο'),
				getOfferTextBlock(MonetizationType.Rent, ' ως αρχείο λήψης ή να τον ενοικιάσετε στο', 'online'),
				'. ',
			];
		case 'sr':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'Možete kupiti', 'na'),
				getOfferTextBlock(MonetizationType.Rent, ' kao preuzimanje ili iznajmiti na', 'onlajn'),
				'. ',
			];
		case 'sv':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'Du kan köpa', 'på'),
				getOfferTextBlock(MonetizationType.Rent, ' som nedladdning eller hyra den på', 'online'),
				'. ',
			];
		case 'uk':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'Ви можете придбати і завантажити', 'на'),
				getOfferTextBlock(MonetizationType.Rent, ' або взяти напрокат онлайн на'),
				'. ',
			];
		case 'ur':
			return [
				getInfoTextBlock(MonetizationType.Buy, 'آپ', 'کو'),
				getOfferTextBlock(
					MonetizationType.Rent,
					' پر ڈاؤن لوڈ کے طور پر خرید سکتے ہیں یا اسے ',
					'پر آن لائن کرائے پر لے سکتے ہیں۔'
				),
			];
		case 'zh':
			return [
				getRTLInfoTextBlock(MonetizationType.Buy, '你可以在', '上购买下载', ','),
				getOfferTextBlock(MonetizationType.Rent, ' 或在', '在线租赁'),
			];
		case 'en':
		default:
			return [
				getInfoTextBlock(MonetizationType.Buy, 'You can buy', 'on', 'as download'),
				getOfferTextBlock(MonetizationType.Rent, ' or rent it on', 'online'),
				'. ',
			];
	}
});

return { __sfc: true,language, props, getOfferTextBlock, getInfoTextBlock, getRTLInfoTextBlock, text }
}

})